export default "__VITE_ASSET__aSch$bn8__"